import classNames from 'classnames';
import React from 'react';

import './CourseCollaboration.scss';

interface IProps {
  isPreview?: boolean;
  fileSource?: string;
}

export const CourseCollaboration = ({ isPreview, fileSource }: IProps) => {
  return (
    <div className={classNames('CourseCollaboration d-flex align-items-center', { isPreview })}>
      Made in collaboration with
      <div className="CourseCollaboration-logo-container">
        <img src={fileSource} alt="Collaboration Logo Preview" />
      </div>
    </div>
  );
};
